<template>
  <section>
    <h3 class="boss-joboffer-title boss-setting margin-top-1">
      面接情報の設定
    </h3>
    <div class="grid-x align-justify">
      <p class="boss-text boss-annotation-text">
        ※こちらは企業様に直接設定していただく項目となります<br>※専用応募フォームを設定している求人は、面接情報は掲出できません<br>※掲載中の面接情報は削除できません
      </p>
      <div class="medium-4 cell">
        <button
          class="float-right boss-button boss-button-new"
          data-test="create-interview"
          @click="$router.push({ name: 'interviewRegister' })"
        >
          <span class="boss-icon-new" />
          <span class="boss-button-new-text">新規作成</span>
        </button>
      </div>
    </div>
    <table
      class="unstriped boss-table"
    >
      <thead>
        <tr>
          <th class="boss-table-head-center">
            作成日
          </th>
          <th class="boss-table-head-center">
            更新日
          </th>
          <th class="boss-table-head-center">
            面接情報ページ名
          </th>
          <th class="boss-table-head-center">
            ステータス
          </th>
          <th class="boss-table-head-center">
            操作メニュー
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="interviewCountermeasures.length">
          <tr
            v-for="(interviewCountermeasure, i) in interviewCountermeasures"
            :key="i"
          >
            <td
              class="boss-table-data"
              :data-test="`interview-create-date-${i}`"
            >
              {{ interviewCountermeasure.insertDate }}
            </td>
            <td
              class="boss-table-data"
              :data-test="`interview-update-date-${i}`"
            >
              {{ interviewCountermeasure.updateDate }}
            </td>
            <td
              class="boss-table-data"
              :data-test="`interview-countermeasure-name-${i}`"
            >
              {{ interviewCountermeasure.interviewCountermeasureName }}
            </td>
            <td
              :class="{ 'boss-annotation-text': !interviewCountermeasure.isPublishedJob }"
              class="boss-table-data"
              :data-test="`interview-publish-status-${i}`"
            >
              {{ interviewCountermeasure.isPublishedJob | publishedLabel }}
            </td>
            <td
              class="boss-table-data"
            >
              <div class="boss-batch-select padding-top-0">
                <template v-for="(button, index) in buttons">
                  <span
                    :key="index"
                  >
                    <router-link
                      v-if="button.to"
                      class="boss-button boss-exe-button pega-button pega-mr-5 pega-bulk-button margin-03"
                      :data-test="`interview-button-name-${i}-${index}`"
                      :to="button.to(interviewCountermeasure.id)"
                      target="_blank"
                    >{{ button.label }}</router-link>
                    <button
                      v-else
                      class="boss-button boss-exe-button pega-button pega-mr-5 pega-bulk-button margin-03"
                      :disabled="button.isDisabled(interviewCountermeasure.isPublishedJob)"
                      :data-test="`interview-button-name-${i}-${index}`"
                      @click="button.onClick(interviewCountermeasure.id)"
                    >
                      <span class="boss-exe-button-text">{{ button.label }}</span>
                    </button>
                  </span>
                </template>
              </div>
            </td>
          </tr>
        </template>
        <tr v-else>
          <td
            colspan="5"
            data-test="no-interviews"
          >
            ※面接情報がまだ作成されていません
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>

export default {
  filters: {
    publishedLabel (val) {
      return val ? '掲載中' : '未掲載'
    }
  },
  props: {
    interviewCountermeasures: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      buttons: [
        {
          label: 'プレビュー',
          to: (interviewCountermeasureId) => {
            return { name: 'interviewPreview', params: { interviewCountermeasureId: interviewCountermeasureId } }
          },
          isDisabled: () => false
        },
        {
          label: 'コピー',
          onClick: (interviewCountermeasureId) => this.copyInterviewCountermeasure(interviewCountermeasureId),
          isDisabled: () => false
        },
        {
          label: '編集',
          onClick: (interviewCountermeasureId) => this.$router.push({ name: 'interviewEdit', params: { interviewCountermeasureId: interviewCountermeasureId } }),
          isDisabled: () => false
        },
        {
          label: '設定／解除',
          onClick: (interviewCountermeasureId) => this.$router.push({ name: 'interviewSettings', params: { interviewCountermeasureId: interviewCountermeasureId } }),
          isDisabled: () => false
        },
        {
          label: '削除',
          onClick: (interviewCountermeasureId) => this.doRemove(interviewCountermeasureId),
          isDisabled: (isPublish) => isPublish
        }
      ]
    }
  },
  methods: {
    deleteInterviewCountermeasure (interviewCountermeasureId) {
      return this.$http.secured.delete(`/interview_countermeasures/${interviewCountermeasureId}`)
    },
    copyInterviewCountermeasure (interviewCountermeasureId) {
      this.$http.secured.post(`/interview_countermeasures/${interviewCountermeasureId}/_copy`).then(response => {
        this.$toasted.global.success({ message: '面接情報のコピーを作成しました。' })
        this.$emit('fetchInterviewCountermeasures')
      })
    },
    doRemove (interviewCountermeasureId) {
      this.$dialog.confirm('削除しますか？')
        // はいを押下した時
        .then(() => {
          this.deleteInterviewCountermeasure(interviewCountermeasureId) // 削除して
            .then(() => {
              this.$toasted.global.success({ message: '面接情報を削除しました。' })
              this.$emit('fetchInterviewCountermeasures')
            })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
